import getAssetUrl from 'utils/getAssetUrl';

// Index-aligned with pages.home.conservationCarousel in the locale catalog.
export const conservationImages = [
  getAssetUrl('/assets/carousel/FOTO_1.jpg'),
  getAssetUrl('/assets/carousel/FOTO_2.jpg'),
  getAssetUrl('/assets/carousel/FOTO_3.jpg'),
  getAssetUrl('/assets/carousel/FOTO_4.jpg'),
  getAssetUrl('/assets/carousel/FOTO_5.jpg'),
  getAssetUrl('/assets/carousel/FOTO_6.jpg'),
];

export const dropImgUrl = getAssetUrl('/assets/images/landing/drop.jpeg');

export const youtubeEmbedId = 'pq2If5-JFOc';
